<template>
  <nav class="header-nav">
    <div class="container">
      <router-link :class="{ active: activeLink == 'company' }" to="/company"
        >Hồ sơ công ty</router-link
      ><!--企業概要-->
      <router-link
        :class="{ active: activeLink == 'intro' }"
        to="/company/intro"
        >Mục đích kinh doanh, triết lý doanh nghiệp, chính sách nghề nghiệp</router-link
      ><!--企業宗旨、企業理念、事業方針-->
      <router-link
        :class="{ active: activeLink == 'philosophy' }"
        to="/company/philosophy"
        >Thông điệp từ tổng thống</router-link
      ><!--社長的話-->
    </div>
  </nav>
</template>
<script>
export default {
  name: "CompanyHeaderNav",
  props: ["activeLink"],
};
</script>
